<template>
    <div class="container py-4">
        <div class="row">
            <div v-if="hideTitle === false" class="row">
                <div class="col-12">
                    <h2 class="text-color-dark font-weight-bold text-12 mb-2 pt-0 mt-0">{{ $t('hi.artworks') }}</h2>
                    <div class="divider divider-primary divider-small">
                        <hr class="w-25 text-left custom-h-1 dividerProgress25">
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="blog-posts">
                    <div class="row products product-thumb-info-list">
                        <div  v-if="items.data.length > 0" v-for="item in items.data" :key="item.id" class="col-sm-6 col-lg-4">
                            <div class="product mb-0">
                                <div class="product-thumb-info border-0 mb-3">
                                    <router-link :to="{name:'artworksViewFrontend', params:{id:item.slug}}">
                                        <div class="product-thumb-info-image">
                                            <img alt="" class="img-fluid" :src="item.image_url">
                                        </div>
                                    </router-link>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <span class="d-block text-uppercase text-decoration-none text-color-default text-color-hover-primary line-height-1 text-0 mb-1"><span v-for="category in item.categories">{{ category.translations.find(o=>o.locale===$i18n.locale).name }}</span></span>
                                        <h3 class="text-3-5 font-weight-bold font-alternative text-transform-none line-height-3 mb-0">
                                            <router-link :to="{name:'artworksViewFrontend', params:{id:item.slug}}" class="text-color-dark text-color-hover-primary">{{ item.name }}</router-link>
                                        </h3>
                                    </div>
                                </div>
                                <p v-if="$props.hideArtistName===false" class="text-3-4">{{ $t('hi.author') }}: <router-link :to="{name:'authorsViewFrontend', params:{slug:item.author.slug}}" target="_blank" class="text-color-dark text-color-hover-primary">{{ item.author.full_name }}</router-link></p>
                                <p v-if="$props.hideOnSale===false" class="text-3-4">{{ (item.on_salable)?$t('hi.on_sale'): $t('hi.not_on_sale')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" v-if="loadMore === false">
                            <pagination v-if="urlAppend == ''"></pagination>
                            <pagination v-else :url-append="urlAppend"></pagination>
                        </div>
                    </div>
                </div>
                <div v-if="items.data.length === 0" class="col-12 alert alert-info">{{ $t('hi.without_artworks')}}</div>
            </div>
        </div>
        <component :is="modalComponent" :modal=modal></component>
    </div>
</template>

<script>
export default {
    name: "ListArtworks",
    props:{
        authorId: {
            type: [String, Number],
        },
        onlySale: {
            type: [String, Number],
            default: 1
        },
        hideTitle: {
            type: Boolean,
            default: false,
        },
        hideArtistName: {
            type: Boolean,
            default: false,
        },
        hideOnSale: {
            type: Boolean,
            default: true,
        },
        categoriesIds: Array,
        except: {
            type: [String, Number],
        },
        loadMore: {
            type: Boolean,
            default: false,
        },
    },
    beforeMount() {
        this.setUrl();
    },
    data(){
        return{
            items: {data:[]},
            apiRoute: '/api/artworks',
            apiRouteCategories: '/api/categories',
            urlAppend: '',
            pageTitle: this.$i18n.t('hi.artworks'),
            category: null,
            modalComponent: null,
            modal:{},
        }
    },
    methods:{
      getModal(id){
          this.axios.get(`${this.apiRouteCategories}/${id}`)
              .then(response=>{
                  if(typeof response.data.modal === 'object'){
                      this.modalComponent = 'modal-frontend';
                      this.modal = response.data.modal;
                  }
              })
              .catch(error=>{
                  this.$swal({
                      title: this.$i18n.t('hi.unknown_error'),
                      icon: 'error',
                      timer: 3000,
                      showCancelButton: false,
                      showCloseButton: false,
                      showConfirmButton: false
                  })
              })
      },
      setUrl(){
          let props = this.$props;
          let sep = '?';
          this.urlAppend = '';
          for (var [key, value] of Object.entries(this.$route.query)) {
              this.urlAppend =  this.urlAppend +sep+key+'='+value
              sep= '&'
              if(key === 'category_id[]'){
                  this.getModal(value);
              }
          }
          if(typeof this.$props.authorId!='undefined'){
              this.urlAppend =  this.urlAppend +sep+'author_id='+this.$props.authorId
              if(this.$props.loadMore) {
                  this.$route.query.author_id = this.$props.authorId;
              }
              sep= '&'
          }
          if(typeof this.$props.categoriesIds!=='undefined'){
              if(typeof this.$route.query.category_id == 'undefined') {
                  this.$route.query.category_id = this.$props.categoriesIds.map(e=> e.value);
              }
              for (var i in this.$props.categoriesIds) {
                  this.urlAppend = this.urlAppend + sep + 'category_id[]=' + this.$props.categoriesIds[i];
                  sep= '&'
              }
          }
          if(typeof this.$props.except !== 'undefined'){
              this.urlAppend =  this.urlAppend +sep+'except='+this.$props.except
              if(this.$props.loadMore) {
                  this.$route.query.except = this.$props.except;
              }
              sep= '&'
          }
          if(typeof this.$props.onlySale !== 'undefined'){
              this.urlAppend =  this.urlAppend +sep+'on_salable='+this.$props.onlySale
              if(this.$props.loadMore) {
                  this.$route.query.onlySale = this.$props.onlySale;
              }
              sep= '&'
          }
      }
    },
    watch: {
        categoriesIds: function (newVal, oldVal){
            this.setUrl()
        },
        authorId: function (newVal, oldVal){
            this.setUrl()
        },
        onlySale: function (newVal, oldVal){
            this.setUrl()
        }
    }
}
</script>

<style scoped>

</style>
